import axios from "../helper/Axios.js";
import { adminUrl } from "../config/config.js";
// import { Delete, Get, Patch, Post, Put } from "./RestClient.js";

export async function getPlaces({
    queryParams
}) {
    try {
        let places = await axios.Get({
            url: `${adminUrl}/place-list`,
            params: {
                ...queryParams
            }
        });

        if (places.statusCode !== 200) {
            return { error: places.message };
        }

        return { data: places.data };
    } catch (e) {
        return { error: e.response.data };
    }
}

export async function createPlaces(data) {
    try {
        let places = await axios.Post({
            url: `${adminUrl}/place-create`,
            data: data
        });

        if (places.statusCode !== 200) {
            return { error: places.message };
        }

        return { data: places.data };
    } catch (e) {
        return { error: e.response.data };
    }
}

export async function getPlaceDetail(id) {
    try {
        let place = await axios.Get({
            url: `${adminUrl}/place/${id}`,
        });
        if (place.statusCode !== 200) {
            return { error: place.message };
        }
        return { data: place.data };
    } catch (e) {
        return { error: e.response.data };
    }
}

export async function updatePlaces(data) {
    try {
        let place = await axios.Post({
            url: `${adminUrl}/place-update`,
            data: data
        });

        if (place.statusCode !== 200) {
            return { error: place.message };
        }
        return { data: place.data };
    } catch (e) {
        return { error: e.response.data };
    }
}

export async function getCourts(placeId, date, userId) {
    try {
        let place = await axios.Get({
            url: `${adminUrl}/courts?place=${placeId || ''}&date=${date || ''}&userId=${userId || ''}`,
        });

        if (place.statusCode !== 200) {
            return { error: place.message };
        }
        return { data: place.data };
    } catch (e) {
        return { error: e.response.data };
    }
}

export async function getCourtsSchedule(court, day) {
    try {
        let place = await axios.Get({
            url: `${adminUrl}/courts-schedule?court=${court}&day=${day}`,
        });

        if (place.statusCode !== 200) {
            return { error: place.message };
        }
        return { data: place.data };
    } catch (e) {
        return { error: e.response.data };
    }
}

export async function setCourtsRainRefund({
    placeId, status, rainRefundTime
}) {
    try {
        let place = await axios.Post({
            url: `${adminUrl}/courts-rain-refund`,
            data: {
                placeId,
                status,
                rainRefundTime
            }
        });

        if (place.statusCode !== 200) {
            return { error: place.message };
        }
        return { data: place.data };
    } catch (e) {
        return { error: e.response.data };
    }
}

export const getServerTime = async function () {
    try {
        let response = await axios.Get('/server-date');
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (e) {
        return { error: e.response.data };
    }
}

export async function getCourtTypes({
    queryParams, isAllCourt, isActive
}) {
    try {
        let courtTypes = await axios.Get({
            url: `${adminUrl}/court-type-list`,
            params: {
                queryParams: queryParams || '',
                isAllCourt: isAllCourt || '',
                isActive: isActive || ''
            }
        });

        if (courtTypes.statusCode !== 200) {
            return { error: courtTypes.message };
        }

        return { data: courtTypes.data };
    } catch (e) {
        return { error: e.response.data };
    }
}

export async function getSportCourtTypes({
    queryParams, isActive, merchantId, placeId
}) {
    try {
        let data = await axios.Get({
            url: `${adminUrl}/sport-court-types`,
            params: {
                queryParams: queryParams || '',
                isActive: isActive || '',
                merchantId: merchantId || '',
                placeId: placeId || ''
            }
        });

        if (data.statusCode !== 200) {
            return { error: data.message };
        }

        return { data: data.data };
    } catch (e) {
        return { error: e.response.data };
    }
}

export const getAllowedCourtSettings = async function (placeId) {
    // court-settings
    try {
        let response = await axios.Get({
            url: `${adminUrl}/courts-settings?placeId=${placeId}`,
        });
        if (response.statusCode !== 200) { throw response.data; }
        let data = response.data;
        return { data };
    } catch (e) {
        return { error: e.response.data };
    }
}

export const updateCourtSettings = async function (placeId, body) {
    // court-settings
    try {
        let response = await axios.Post({
          url: `${adminUrl}/courts-settings`,
          data: {
            placeId,
            ...body
          }   
        });
        if (response.statusCode !== 200) { throw response.data; }
        let data = response.data;
        return { data };
    } catch (e) {
        return { error: e.response.data };
    }
}